import useOrganizationsStore from "@lib/store/organization";

export default defineNuxtRouteMiddleware(async (to) => {
  const $router = useRouter();
  const { $auth, $organization } = useNuxtApp();
  const orgStore = useOrganizationsStore();

  if (to.path.startsWith("/clients")) {
    return $router.replace({ path: "/advisor" });
  }
  if ($auth.loggedIn && to.params.org_id) {
    let orgs = orgStore.organizations;
    if (!orgs || !orgs.length) {
      await orgStore.fetchOrganizations();
    }
    orgs = orgStore.organizations;
    const org = orgs.find((org) => org.public_id === to.params.org_id);
    if (!org) {
      $organization.setCurrent(null);
      return $router.replace({ path: "/advisor" });
    }
    if (to.params.org_id !== orgStore.organization?.public_id) {
      $organization.setCurrent(org);
    }
  }
});
